import { j as t } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { c as a } from "../../chunks/index.C4-GUKyp.js";
import { c as i } from "../../chunks/index.CxSWpsOB.js";
import { T as b } from "../../chunks/Text.BGhoO_e3.js";
const m = a("tw-inline-flex tw-items-center tw-rounded-full tw-font-semibold tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2", {
  variants: {
    variant: {
      default: "tw-text-gray-600",
      red: "tw-border tw-box-border tw-border-red-900 tw-bg-red-100 tw-text-red-900",
      "dark-red": "tw-bg-red-900 tw-text-red-100",
      blue: "tw-border tw-box-border tw-border-blue-800 tw-bg-blue-100 tw-text-blue-800",
      green: "tw-border tw-box-border tw-border-green-900 tw-bg-green-100 tw-text-green-900",
      yellow: "tw-border tw-box-border tw-border-yellow-900 tw-bg-yellow-200 tw-text-yellow-900"
    },
    size: {
      none: "tw-px-0 tw-py-8 tw-h-24",
      sm: "tw-px-8 tw-py-4 tw-caption-2-m tw-h-20",
      md: "tw-px-8 tw-py-8 tw-text-base tw-h-24"
    },
    border: {
      solid: "",
      none: "tw-border-0 tw-border-none"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "none",
    border: "solid"
  }
}), x = ({
  border: o,
  children: w,
  className: n,
  prefix: e,
  size: s,
  suffix: r,
  variant: l,
  ...d
}) => /* @__PURE__ */ t.jsxs("div", { className: i(m({
  border: o,
  size: s,
  variant: l
}), n), ...d, children: [
  !!e && /* @__PURE__ */ t.jsx("span", { className: "tw-flex tw-items-center tw-mr-4", children: e }),
  /* @__PURE__ */ t.jsx(b, { typeface: "body-1-m", children: w }),
  !!r && /* @__PURE__ */ t.jsx("span", { className: "tw-flex tw-items-center tw-ml-4", children: r })
] });
x.displayName = "StatusPill";
export {
  x as StatusPill,
  m as pillVariants
};
//# sourceMappingURL=index.js.map
